
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface SEOProps {
  title?: string;
  description?: string;
  ogType?: string;
  ogImage?: string;
  canonical?: string;
  dynamicData?: {
    title?: string;
    description?: string;
    ogType?: string;
    ogImage?: string;
  };
}

export const SEO = ({ title, description, ogType, ogImage, canonical, dynamicData }: SEOProps) => {
  const location = useLocation();

  useEffect(() => {
    const finalTitle = dynamicData?.title || title || "Slay - LGBTQIA+ Events";
    const finalDescription = dynamicData?.description || description || "Discover and attend amazing LGBTQIA+ events in your area";
    const finalOgType = dynamicData?.ogType || ogType || "website";
    const finalOgImage = dynamicData?.ogImage || ogImage || "https://slay.events/og-image.png";

    // Update document title
    document.title = finalTitle;

    // Update meta tags
    const metaTags = {
      'description': finalDescription,
      'og:title': finalTitle,
      'og:description': finalDescription,
      'og:type': finalOgType,
      'og:url': `https://slay.events${location.pathname}`,
      'og:image': finalOgImage,
    };

    // Update or create meta tags
    Object.entries(metaTags).forEach(([name, content]) => {
      if (!content) return;

      let metaTag = document.querySelector(`meta[name="${name}"]`) ||
                   document.querySelector(`meta[property="${name}"]`);
                   
      if (!metaTag) {
        metaTag = document.createElement('meta');
        if (name.startsWith('og:')) {
          metaTag.setAttribute('property', name);
        } else {
          metaTag.setAttribute('name', name);
        }
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    });

    // Handle canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (canonical) {
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute('href', canonical);
    } else if (canonicalLink) {
      canonicalLink.remove();
    }
  }, [title, description, ogType, ogImage, canonical, dynamicData, location.pathname]);

  return null;
};
